import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { deal_alarm, get_filter_rule as _get_filter_rule, query_alert_history_aggregate as _query_alert_history_aggregate, query_alert_history as _query_alert_history } from "../../services/Company/companyS";
import { get_history_event_case, get_event_case, get_sub_event_case, deal_event_case, get_alarm_reason as _get_alarm_reason, deal_sub_event_case as _deal_sub_event_case, get_group_by_label as _get_group_by_label, get_group_by_priority as _get_group_by_priority } from "../../services/MI/MI1801S";
import { _crypto } from "../../utils/commonUtilFunc";
import { BossMessage } from "../../components/Common/BossMessages";
import { get_company_list, get_strategy_label as _get_strategy_label } from "../../services/Company/companyS";
export default {
  namespace: "mi1801Info",
  state: {
    tempPayload: {},
    alarmList: [],
    pastAlarmList: [],
    noteList: [],
    companyList: [],
    total: 0,
    noteTotal: 0,
    case_events_payload: {},
    reasonList: [],
    labelName: [],
    priorityGroupList: [],
    prioritySum: 0,
    labelGroupList: [],
    labelSum: 0,
    strategyLabelList: [],
    alarmListTotal: 0,
    noteListTotal: 0
  },
  effects: {
    process: function process(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return put({
                type: "update",
                payload: {
                  tempPayload: payload.update
                }
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_alarm_reason: function get_alarm_reason(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_get_alarm_reason, payload);
            case 2:
              backData = _context2.sent;
              _context2.next = 5;
              return put({
                type: "update",
                payload: {
                  reasonList: backData.result
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    getCompanyList: function getCompanyList(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(get_company_list, payload);
            case 2:
              backData = _context3.sent;
              _context3.next = 5;
              return put({
                type: "update",
                payload: {
                  companyList: backData && backData.result && Array.isArray(backData.result) ? backData.result : []
                }
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    confirm: function confirm(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put,
        select = _ref8.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var temp, payloadUsed, data, backData1, backData2;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return select(function (state) {
                return state.mi1801Info.tempPayload;
              });
            case 2:
              temp = _context4.sent;
              payloadUsed = {
                alarm_id: temp.alarm_id,
                password: _crypto(payload.update.password),
                sn: temp.sn,
                remark: temp.remark,
                cmd: temp.debug
              };
              data = {
                "ids": [temp.alarm_id],
                "reason": temp.reason ? temp.reason : "",
                "remark": temp.reason ? temp.remark : "",
                "restrain": {}
              };
              backData1 = {}, backData2 = {};
              if (!temp.debug) {
                _context4.next = 22;
                break;
              }
              _context4.next = 9;
              return call(deal_event_case, data);
            case 9:
              backData1 = _context4.sent;
              _context4.next = 12;
              return call(deal_alarm, payloadUsed);
            case 12:
              backData2 = _context4.sent;
              if (!(backData2.success && backData1.retcode === 0)) {
                _context4.next = 19;
                break;
              }
              BossMessage(true, "Operation successful");
              _context4.next = 17;
              return put({
                type: "get_redis_alarm",
                payload: payload.init
              });
            case 17:
              _context4.next = 20;
              break;
            case 19:
              BossMessage(false, "operation failed");
            case 20:
              _context4.next = 32;
              break;
            case 22:
              _context4.next = 24;
              return call(deal_event_case, data);
            case 24:
              backData1 = _context4.sent;
              if (!(backData1.retcode === 0)) {
                _context4.next = 31;
                break;
              }
              BossMessage(true, "Operation successful");
              _context4.next = 29;
              return put({
                type: "get_redis_alarm",
                payload: payload.init
              });
            case 29:
              _context4.next = 32;
              break;
            case 31:
              BossMessage(false, "operation failed");
            case 32:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    // * get_redis_alarm({payload}, {call, put}) {
    //     const backData = yield call(get_redis_alarm, payload);
    //     yield put({
    //         type: "update",
    //         payload: {
    //             alarmList: backData.result,
    //             total: backData.total
    //         }
    //     })
    // }
    ignore: function ignore(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              // let data = {
              //     "ids":["s_100_e29400850ad933644dfca951d298de13"],
              //     "reason":"",
              //     "remark":"",
              //     "restrain":{
              //       "time_list":[
              //         {
              //           "begin_time": 1544601574,
              //             "end_time": 1544601584
              //         }],
              //       "is_cycle":1,
              //       "type":"all",
              //       "remark":""
              //     }
              //   }
              data = {
                "ids": payload.update.ids,
                "reason": payload.update.reason ? payload.update.reason : "",
                "remark": payload.update.reason ? payload.update.remark : "",
                "restrain": payload.update.reason ? {} : {
                  "time_list": [{
                    "begin_time": payload.update.start_time,
                    "end_time": payload.update.end_time
                  }],
                  "is_cycle": payload.update.is_cycle ? 1 : 0,
                  "type": payload.update.restrain_type,
                  "remark": payload.update.remark
                }
              };
              _context5.next = 3;
              return call(deal_event_case, data);
            case 3:
              backData = _context5.sent;
              if (!(backData.retcode === 0)) {
                _context5.next = 12;
                break;
              }
              BossMessage(true, "Operation successful");
              _context5.next = 8;
              return put({
                type: "get_redis_alarm",
                payload: payload.init
              });
            case 8:
              _context5.next = 10;
              return put({
                type: "get_event_case_events_all",
                payload: payload.init
              });
            case 10:
              _context5.next = 13;
              break;
            case 12:
              BossMessage(false, "operation failed" + backData.msg);
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    query_alert_history_aggregate: function query_alert_history_aggregate(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_query_alert_history_aggregate, payload);
            case 2:
              backData = _context6.sent;
              _context6.next = 5;
              return put({
                type: "update",
                payload: {
                  alarmList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  alarmListTotal: backData.data.total // total: backData.total
                }
              });
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    get_redis_alarm: function get_redis_alarm(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(get_event_case, payload);
            case 2:
              backData = _context7.sent;
              if (!(payload.process_status === 'resolved')) {
                _context7.next = 8;
                break;
              }
              _context7.next = 6;
              return put({
                type: "update",
                payload: {
                  pastAlarmList: backData.data,
                  pastTotal: backData.total
                }
              });
            case 6:
              _context7.next = 10;
              break;
            case 8:
              _context7.next = 10;
              return put({
                type: "update",
                payload: {
                  alarmList: backData.data,
                  total: backData.total
                }
              });
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    get_event_case_events_all: function get_event_case_events_all(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(get_history_event_case, payload);
            case 2:
              backData = _context8.sent;
              _context8.next = 5;
              return put({
                type: "update",
                payload: {
                  pastAlarmList: backData.data,
                  pastTotal: backData.total
                }
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    query_alert_history: function query_alert_history(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_query_alert_history, payload);
            case 2:
              backData = _context9.sent;
              _context9.next = 5;
              return put({
                type: "update",
                payload: {
                  noteList: backData.data && backData.data.result && Array.isArray(backData.data.result) ? backData.data.result : [],
                  noteListTotal: backData.data.total // noteTotal: backData.total,
                  // case_events_payload:payload,
                }
              });
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    get_event_case_events: function get_event_case_events(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(get_sub_event_case, payload);
            case 2:
              backData = _context10.sent;
              _context10.next = 5;
              return put({
                type: "update",
                payload: {
                  noteList: backData.data,
                  noteTotal: backData.total,
                  case_events_payload: payload
                }
              });
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    deal_sub_event_case: function deal_sub_event_case(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put,
        select = _ref22.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var case_events_payload, payloadUsed, backData;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return select(function (state) {
                return state.mi1801Info.case_events_payload;
              });
            case 2:
              case_events_payload = _context11.sent;
              payloadUsed = {
                "event_caseId": payload.update.event_caseId,
                "reason": payload.update.reason,
                "remark": payload.update.remark || "",
                "ids": payload.update.ids2
              };
              _context11.next = 6;
              return call(_deal_sub_event_case, payloadUsed);
            case 6:
              backData = _context11.sent;
              if (!(backData.retcode === 0)) {
                _context11.next = 13;
                break;
              }
              BossMessage(true, "Operation successful");
              _context11.next = 11;
              return put({
                type: "get_event_case_events",
                payload: case_events_payload
              });
            case 11:
              _context11.next = 14;
              break;
            case 13:
              BossMessage(false, "operation failed" + backData.msg);
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    get_group_by_label: function get_group_by_label(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData, labelSum, data;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_get_group_by_label, payload);
            case 2:
              backData = _context12.sent;
              labelSum = 0, data = [];
              if (backData.data && backData.data.length > 0) {
                data = backData.data;
                backData.data.map(function (item) {
                  labelSum = Number(labelSum) + Number(item.count);
                });
              }
              _context12.next = 7;
              return put({
                type: "update",
                payload: {
                  labelGroupList: data,
                  labelSum: labelSum
                }
              });
            case 7:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    get_filter_rule: function get_filter_rule(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData, data;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_get_filter_rule, payload);
            case 2:
              backData = _context13.sent;
              data = backData.data[0].apps[0].rules.filter(function (item) {
                return item.property === 'label_name';
              })[0];
              _context13.next = 6;
              return put({
                type: "update",
                payload: {
                  labelName: data && data.value ? data.value : ""
                }
              });
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    get_group_by_priority: function get_group_by_priority(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData, prioritySum, data;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(_get_group_by_priority, payload);
            case 2:
              backData = _context14.sent;
              prioritySum = 0, data = [];
              if (backData.data && backData.data.length > 0) {
                data = backData.data;
                backData.data.map(function (item) {
                  prioritySum = Number(prioritySum) + Number(item.count);
                });
              }
              _context14.next = 7;
              return put({
                type: "update",
                payload: {
                  priorityGroupList: data,
                  prioritySum: prioritySum
                }
              });
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    get_strategy_label: function get_strategy_label(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_get_strategy_label, payload);
            case 2:
              backData = _context15.sent;
              _context15.next = 5;
              return put({
                type: "update",
                payload: {
                  strategyLabelList: backData && backData.data && Array.isArray(backData.data) ? backData.data : []
                }
              });
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};